
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import LineChart from '../LineChart/index.vue'
import type { MyClassroomType } from '@xt/client/entities/my-v2/types'

@Observer
@Component({
  components: {
    LineChart
  }
})
export default class StudyRecord extends Vue {
  @Prop() dataSource: MyClassroomType['StudyRecord']

  // LineChart 组件配置
  get chartContent() {
    return {
      dataSource: this.dataSource.lastWeekLearnData.map(item => item.time),
      config: {
        lineWidth: 1,
        lineColor: '#F1E0E0',
        containerW: 275,
        containerH: 26,
        innerRadius: 1.5,
        outerRadius: 2.5,
        innerColor: '#F1E0E0',
        outerColor: '#D9A8A8'
      }
    }
  }
  // 数据更新时间
  get updateTime() {
    const now = this.$ajax.serviceDate().utcOffset(+8)
    const weekArr = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']

    return {
      updateTime: now.format('YYYY.MM.DD'),
      updateWeekDay: weekArr[now.day()]
    }
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
